module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }